__turbopack_context__.v({
  "authorAvatar": "ParagraphSplitTextStickyCta-module__BvCb9W__authorAvatar",
  "authorName": "ParagraphSplitTextStickyCta-module__BvCb9W__authorName",
  "authorRole": "ParagraphSplitTextStickyCta-module__BvCb9W__authorRole",
  "authorRow": "ParagraphSplitTextStickyCta-module__BvCb9W__authorRow",
  "authorText": "ParagraphSplitTextStickyCta-module__BvCb9W__authorText",
  "checkIcon": "ParagraphSplitTextStickyCta-module__BvCb9W__checkIcon",
  "duration": "ParagraphSplitTextStickyCta-module__BvCb9W__duration",
  "durationIcon": "ParagraphSplitTextStickyCta-module__BvCb9W__durationIcon",
  "eligibility": "ParagraphSplitTextStickyCta-module__BvCb9W__eligibility",
  "eligibilityCheck": "ParagraphSplitTextStickyCta-module__BvCb9W__eligibilityCheck",
  "eligibilityHeader": "ParagraphSplitTextStickyCta-module__BvCb9W__eligibilityHeader",
  "eligibilityIcon": "ParagraphSplitTextStickyCta-module__BvCb9W__eligibilityIcon",
  "eligibilityItem": "ParagraphSplitTextStickyCta-module__BvCb9W__eligibilityItem",
  "eligibilityItems": "ParagraphSplitTextStickyCta-module__BvCb9W__eligibilityItems",
  "eligibilityNote": "ParagraphSplitTextStickyCta-module__BvCb9W__eligibilityNote",
  "eligibilityTitle": "ParagraphSplitTextStickyCta-module__BvCb9W__eligibilityTitle",
  "featureItem": "ParagraphSplitTextStickyCta-module__BvCb9W__featureItem",
  "features": "ParagraphSplitTextStickyCta-module__BvCb9W__features",
  "featuresTitle": "ParagraphSplitTextStickyCta-module__BvCb9W__featuresTitle",
  "footerNote": "ParagraphSplitTextStickyCta-module__BvCb9W__footerNote",
  "highlight": "ParagraphSplitTextStickyCta-module__BvCb9W__highlight",
  "highlightIcon": "ParagraphSplitTextStickyCta-module__BvCb9W__highlightIcon",
  "intro": "ParagraphSplitTextStickyCta-module__BvCb9W__intro",
  "left": "ParagraphSplitTextStickyCta-module__BvCb9W__left",
  "primaryBtn": "ParagraphSplitTextStickyCta-module__BvCb9W__primaryBtn",
  "right": "ParagraphSplitTextStickyCta-module__BvCb9W__right",
  "secondaryBtn": "ParagraphSplitTextStickyCta-module__BvCb9W__secondaryBtn",
  "section": "ParagraphSplitTextStickyCta-module__BvCb9W__section",
  "sidebar": "ParagraphSplitTextStickyCta-module__BvCb9W__sidebar",
  "sidebarDescription": "ParagraphSplitTextStickyCta-module__BvCb9W__sidebarDescription",
  "sidebarNote": "ParagraphSplitTextStickyCta-module__BvCb9W__sidebarNote",
  "sidebarTitle": "ParagraphSplitTextStickyCta-module__BvCb9W__sidebarTitle",
});
